import { SxProps } from '@mui/system';
import Spacings from '../theme/common/spacings';
import dropdownBoxshadow from '../../../styles/common.styles';

const toolbar = {
  '&.MuiToolbar-root': {
    minHeight: '64px',
    padding: 0,
  },
} as SxProps;

const toolbarDivider = {
  position: 'absolute',
  width: '100%',
  left: 0,
  borderColor: 'neutral.80',
} as SxProps;

const iconButton = {
  '&.MuiIconButton-root': {
    marginRight: Spacings.small3,
    padding: Spacings.small2,
    color: 'neutral.30',
    borderRadius: Spacings.small,
    '&:hover': {
      backgroundColor: 'neutral.95',
    },
  },
  '& .MuiSvgIcon-root': {
    fontSize: '16px',
  },
} as SxProps;

const iconButtonBadge = {
  '& .header-badge': {
    top: -5,
    right: -5,
    height: '15px',
    minWidth: '15px',
    padding: '2px 4px',
    typography: 'body6Medium',
    lineHeight: '15px',
    color: 'common.white',
    backgroundColor: 'primary.main',
    borderRadius: '8px',
  },
} as SxProps;

const mobileMenuItemDivider = {
  height: '32px',
  borderColor: 'neutral.80',
} as SxProps;

const topbarDropdownDivider = {
  height: '32px',
  width: '1px',
  marginRight: Spacings.small3,
  backgroundColor: 'neutral.80',
  border: '0 none',
} as SxProps;

const topbarDropdown = (profileAnchorEl: any, primaryMainSvgFilter: any) => ({
  color: 'neutral.30',
  backgroundColor: profileAnchorEl ? 'neutral.90' : '',
  '&> img': {
    filter: profileAnchorEl ? primaryMainSvgFilter : 'none',
  },
});

const subMenu = {
  '& .top-bar-menu': {
    minWidth: '236px',
    padding: '12px',
    borderRadius: Spacings.small2,
    ...dropdownBoxshadow,
  },
  '& .MuiList-root': {
    padding: 0,
  },
} as SxProps;

const subMenuLink = {
  '&.MuiMenuItem-root': {
    justifyContent: 'space-between',
    padding: Spacings.small2,
    typography: 'body3',
    color: 'neutral.30',
    textDecoration: 'none',
    borderRadius: Spacings.small,
    '&:hover': {
      backgroundColor: 'neutral.90',
      textDecoration: 'none',
    },
    '&:active': {
      color: 'primary.main',
      backgroundColor: 'common.white',
    },
  },
} as SxProps;

const subMenuIcon = {
  height: 20,
  width: 20,
  marginLeft: Spacings.small2,
} as SxProps;

const bottomBar = {
  '&.custom-toolbar': {
    columnGap: Spacings.small4,
    minHeight: 48,
    padding: 0,
  },
} as SxProps;

const bottomBarItem = {
  '&.MuiButton-text.MuiButton-colorGhost': {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'baseline',
    height: 'auto',
    padding: '6px 8px',
    typography: 'body3Medium',
    textDecoration: 'none',
    color: 'neutral.10',
    background: 'none',
    '&:hover': {
      color: 'primary.main',
      backgroundColor: 'neutral.90',
    },
  },
  '&.active, &.MuiButton-colorGhost.active': {
    color: 'primary.main',
    '&:after': {
      content: '""',
      position: 'absolute',
      left: 0,
      bottom: '-9px',
      height: '2px',
      width: '100%',
      backgroundColor: 'primary.main',
    },
  },
} as SxProps;

const bootomBarSubMenu = {
  '& .bottom-bar-menu': {
    minWidth: '280px',
    marginTop: '12px',
    padding: Spacings.small2,
    ...dropdownBoxshadow,
  },
  '& .MuiList-root': {
    padding: 0,
  },
  '& a': {
    padding: Spacings.small2,
    typography: 'body3',
    color: 'neutral.30',
    textDecoration: 'none',
    borderRadius: Spacings.small,
    '&:hover': {
      color: 'neutral.10',
      backgroundColor: 'neutral.90',
      textDecoration: 'none',
    },
  },
};

// MOBILE
const useMobileTheme = {
  text: 'neutral.30',
  textActive: 'neutral.10',
  divider: 'neutral.80',
  backgroundColor: '#fff',
  item: 'neutral.90',
  iconFilter: '',
};

const mobileMenuDrawer = {
  '& .full-screen-drawer': {
    width: '100%',
    backgroundColor: useMobileTheme.backgroundColor,
  },
} as SxProps;

const mobileMenu = {
  padding: Spacings.small3,
} as SxProps;

const mobileMenuCloseWrapper = {
  display: 'flex',
  justifyContent: 'flex-end',
  paddingBottom: Spacings.small3,
} as SxProps;

const mobileListsWrapper = {
  marginTop: Spacings.small3,
} as SxProps;

const mobileListDivider = {
  marginY: Spacings.small3,
  borderColor: 'neutral.80',
} as SxProps;

const mobileList = {
  padding: 0,
};

const mobileMenuItem = (isOpen: boolean, highlight: boolean | undefined) => ({
  display: 'block',
  mb: Spacings.small,
  padding: 0,
  '&:last-child': {
    mb: 0,
  },
  '& a.MuiListItemButton-root': {
    padding: '10px',
    color: highlight ? 'neutral.10' : 'neutral.30',
    backgroundColor: highlight ? 'neutral.90' : useMobileTheme.backgroundColor,
    borderRadius: isOpen ? '4px 4px 0 0' : '4px',
    '&:hover': {
      textDecoration: 'none',
      backgroundColor: 'neutral.90',
    },
  },
});

const mobileMenuItemText = {
  margin: 0,
  '& .MuiListItemText-primary': {
    typography: 'body3',
  },
} as SxProps;

const mobileMenuItemWithSubmenu = (isBottomMenu: boolean) => ({
  display: 'flex',
  justifyContent: isBottomMenu ? 'normal' : 'space-between',
  alignItems: 'center',
  columnGap: Spacings.small3,
  '& .custom-icon': {
    height: 20,
    minWidth: 20,
    width: 20,
    svg: {
      verticalAlign: 'middle',
    },
    'path[fill]': {
      fill: '#536077', // neutral.40
    },
  },
});

const mobileSubmenu = {
  padding: 0,
  '& a.MuiListItemButton-root': {
    padding: '6px 10px',
    paddingLeft: Spacings.medium2,
    color: 'neutral.30',
    backgroundColor: 'neutral.95',
  },
} as SxProps;

const mobileSubmenuItem = {
  padding: 0,
} as SxProps;

const mobileSubmenuIcon = {
  height: 'auto',
  width: '24px',
} as SxProps;

export default {
  toolbar,
  toolbarDivider,
  iconButton,
  iconButtonBadge,
  mobileMenuItemDivider,
  topbarDropdownDivider,
  topbarDropdown,
  subMenu,
  subMenuLink,
  subMenuIcon,
  bottomBar,
  bottomBarItem,
  bootomBarSubMenu,
  useMobileTheme,
  mobileMenuDrawer,
  mobileMenu,
  mobileMenuCloseWrapper,
  mobileListsWrapper,
  mobileList,
  mobileListDivider,
  mobileMenuItem,
  mobileMenuItemText,
  mobileMenuItemWithSubmenu,
  mobileSubmenu,
  mobileSubmenuItem,
  mobileSubmenuIcon,
};
